import React from 'react'
import styled from 'styled-components'

import { GetLegendTooltipData } from 'pages/Device/ThermostatRthPanel/Legend/tooltipDataBuilder'

import { amps, degreesFahrenheit, rpsToRpm, rpm, rpmToPwm, voltageAC, watts } from 'helpers/formatters'

import { RuntimeHistory } from 'types/RuntimeHistory'

type Props = {
  timeAtCursor: number
  showIndoorUnit?: boolean
  showOutdoor?: boolean
  showOutdoorUnit?: boolean
  rthData: RuntimeHistory | null
  isControlHub: boolean
  isHehm?: boolean
}
const HoverTooltip = ({ timeAtCursor, showIndoorUnit = false, showOutdoor = false, showOutdoorUnit = false, rthData, isControlHub, isHehm = false }: Props) => {
  const hoverData = GetLegendTooltipData(timeAtCursor / 1000, rthData)

  return (
    <>
      { showIndoorUnit && isHehm &&
        <S.AnscillaryContainer><S.AnscillaryDataLabel>Return Static Pressure</S.AnscillaryDataLabel><S.AnscillaryData>{hoverData.returnStaticPressure || '--'}</S.AnscillaryData></S.AnscillaryContainer>
      }

      { showIndoorUnit && !isHehm &&
        <>
          <S.AnscillaryContainer><S.AnscillaryDataLabel>Target Airflow</S.AnscillaryDataLabel> <S.AnscillaryData>{hoverData.targetAirflow || '--'}</S.AnscillaryData></S.AnscillaryContainer>
          <S.AnscillaryContainer><S.AnscillaryDataLabel>Total Static Pressure</S.AnscillaryDataLabel><S.AnscillaryData>{hoverData.staticPressure || '--'}</S.AnscillaryData></S.AnscillaryContainer>
          {isControlHub &&
            <>
              <S.AnscillaryContainer><S.AnscillaryDataLabel>Return Static </S.AnscillaryDataLabel><S.AnscillaryData>{hoverData.returnStaticPressure || '--'}</S.AnscillaryData></S.AnscillaryContainer>
              <S.AnscillaryContainer><S.AnscillaryDataLabel>Supply Static</S.AnscillaryDataLabel> <S.AnscillaryData>{hoverData.supplyStaticPressure || '--'}</S.AnscillaryData></S.AnscillaryContainer>
              {hoverData.idActualSpeedInducer && <S.AnscillaryContainer><S.AnscillaryDataLabel>Actual Inducer Speed</S.AnscillaryDataLabel><S.AnscillaryData>{hoverData.idActualSpeedInducer}</S.AnscillaryData></S.AnscillaryContainer>}
              {hoverData.idCombustionPressureActual && <S.AnscillaryContainer><S.AnscillaryDataLabel>Actual Combustion Pressure</S.AnscillaryDataLabel> <S.AnscillaryData>{hoverData.idCombustionPressureActual}</S.AnscillaryData></S.AnscillaryContainer>}
              {hoverData.idCombustionPressureTarget && <S.AnscillaryContainer><S.AnscillaryDataLabel>Target Combustion Pressure</S.AnscillaryDataLabel><S.AnscillaryData>{hoverData.idCombustionPressureTarget}</S.AnscillaryData></S.AnscillaryContainer>}
              {hoverData.idGasValvePositionActual && <S.AnscillaryContainer><S.AnscillaryDataLabel>Actual Gas Valve Stepper Position</S.AnscillaryDataLabel> <S.AnscillaryData>{hoverData.idGasValvePositionActual}</S.AnscillaryData></S.AnscillaryContainer>}
              {hoverData.idGasValvePositionSetpoint && <S.AnscillaryContainer><S.AnscillaryDataLabel>Gas Valve Setpoint</S.AnscillaryDataLabel><S.AnscillaryData>{hoverData.idGasValvePositionSetpoint}</S.AnscillaryData></S.AnscillaryContainer>}
              {hoverData.idTemperatureRise && <S.AnscillaryContainer><S.AnscillaryDataLabel>Temperature Rise - Measured</S.AnscillaryDataLabel><S.AnscillaryData>{hoverData.idTemperatureRise}</S.AnscillaryData></S.AnscillaryContainer>}
              {hoverData.idTemperatureRiseTarget && <S.AnscillaryContainer><S.AnscillaryDataLabel>Target Temperature Rise</S.AnscillaryDataLabel> <S.AnscillaryData>{hoverData.idTemperatureRiseTarget}</S.AnscillaryData></S.AnscillaryContainer>}
              {hoverData.idLineVoltage && <S.AnscillaryContainer><S.AnscillaryDataLabel>Line Voltage</S.AnscillaryDataLabel><S.AnscillaryData>{hoverData.idLineVoltage}</S.AnscillaryData></S.AnscillaryContainer>}
              {hoverData.requestedModulation && <S.AnscillaryContainer><S.AnscillaryDataLabel>Target Demand</S.AnscillaryDataLabel> <S.AnscillaryData>{hoverData.requestedModulation}</S.AnscillaryData></S.AnscillaryContainer>}
            </>
          }
        </>
      }

      {(showOutdoor || showOutdoorUnit) && isHehm &&
        <S.AnscillaryContainer>
          <S.AnscillaryDataLabel>Current</S.AnscillaryDataLabel>
          <S.AnscillaryData>{amps(hoverData.odCurrent) || '--'}</S.AnscillaryData>
        </S.AnscillaryContainer>
      }

      {showOutdoor && !isHehm &&
        <S.AnscillaryContainer>
          <S.AnscillaryDataLabel>Compressor Speed</S.AnscillaryDataLabel>
          <S.AnscillaryData>{hoverData.outdoorCapacity || '--'}</S.AnscillaryData>
        </S.AnscillaryContainer>
      }

      { showOutdoorUnit && !isHehm &&
        <>
          <S.AnscillaryContainer>
            <S.AnscillaryDataLabel>Compressor Speed</S.AnscillaryDataLabel>
            <S.AnscillaryData>
              <span>{hoverData.outdoorCapacity || '--'}</span>
              <span>({rpsToRpm(hoverData.odCompressorActualSpeed) || '--'})</span>
            </S.AnscillaryData>
          </S.AnscillaryContainer>
          {hoverData.odDriveType && hoverData.odDriveType !== 'UNKNOWN' && (
          <>
            {hoverData.odDriveType === 'DANFOSS' &&
            <S.AnscillaryContainer>
              <S.AnscillaryDataLabel>OD Fan PWM</S.AnscillaryDataLabel>
              <S.AnscillaryData>{rpmToPwm(hoverData.odFanSpeed) || '--'}</S.AnscillaryData>
            </S.AnscillaryContainer>
            }

            { (hoverData.odDriveType === 'SINRAPTOR' || hoverData.odDriveType === 'RUBICON') &&
            <S.AnscillaryContainer>
              <S.AnscillaryDataLabel>OD Fan RPM</S.AnscillaryDataLabel>
              <S.AnscillaryData>{rpm(hoverData.odFanSpeed) || '--'}</S.AnscillaryData>
            </S.AnscillaryContainer>
            }
            <S.AnscillaryContainer>
              <S.AnscillaryDataLabel>OD Fan Power</S.AnscillaryDataLabel>
              <S.AnscillaryData>{watts(hoverData.odFanPower) || '--'}</S.AnscillaryData>
            </S.AnscillaryContainer>
            <S.AnscillaryContainer>
              <S.AnscillaryDataLabel>OD Compressor Power </S.AnscillaryDataLabel>
              <S.AnscillaryData>{watts(hoverData.odCompressorPower) || '--'}</S.AnscillaryData>
            </S.AnscillaryContainer>
            <S.AnscillaryContainer>
              <S.AnscillaryDataLabel>OD Line Voltage</S.AnscillaryDataLabel>
              <S.AnscillaryData>{voltageAC(hoverData.odLineVoltage) || '--'}</S.AnscillaryData>
            </S.AnscillaryContainer>
            <S.AnscillaryContainer>
              <S.AnscillaryDataLabel>OD AC Input Current</S.AnscillaryDataLabel>
              <S.AnscillaryData>{amps(hoverData.odCurrent) || '--'}</S.AnscillaryData>
            </S.AnscillaryContainer>
            <S.AnscillaryContainer>
              <S.AnscillaryDataLabel>Compressor Discharge Temp</S.AnscillaryDataLabel>
              <S.AnscillaryData>{degreesFahrenheit(hoverData.odCompressorDischargeTemperature) || '--'}</S.AnscillaryData>
            </S.AnscillaryContainer>
          </>
          )}
        </>
      }
    </>
  )
}

export default HoverTooltip

const S = {
  HeaderText: styled.div`
      font-weight: 800;
    `,
  AnscillaryContainer: styled.div`
      display: flex;
      margin-bottom: 5px;
    `,
  AnscillaryData: styled.div`
      text-transform: capitalize;
    `,
  AnscillaryDataLabel: styled.div`
      display: inline-block;
      cursor: pointer;
      width: 150px;
      font-weigth: 500;
    `
}
